module.exports = __webpack_public_path__ + "static/media/p0_5.dd2ec2a7.png";